// English strings for native PDF exports (OR-11, PB-15-10, PB-14-07; PD-635 – PD-640).
// Arabic: ar-pdf.ts.
export const enPdf = {
  // ------------------------------------------------------------ inside the PDF
  'pdf.page': 'Page {page} of {pages}',
  'pdf.noRows': 'No rows match these filters.',
  'rpt.export.generatedAtSite': 'Generated (site time)',
  // ------------------------------------------------------------ report and roster screens
  'rpt.ui.format.pdf': 'PDF',
  'rpt.ui.downloadPdf': 'Download PDF',
  'rpt.ui.pdfPreparing': 'Preparing the PDF…',
  'rpt.ui.pdfReady': 'The PDF is ready. If the download did not start, use Download in Your exports.',
  'rpt.ui.pdfNotReady': 'The PDF could not be prepared. Check Your exports for the reason.',
  'saf.ui.exportPdf': 'PDF roster',
} as const;
